import React from 'react';
import ToastErrorIcon from './ToastErrorIcon.js';
import ToastSuccessIcon from './ToastSuccessIcon.js';
import ToastWarnIcon from './ToastWarnIcon.js';
export function getIcon(variant) {
    switch (variant) {
        case 'Success':
            return ToastSuccessIcon;
        case 'Warning':
            return ToastWarnIcon;
        case 'Error':
            return ToastErrorIcon;
        default:
            return React.Fragment;
    }
}
//# sourceMappingURL=BKJToastMessage.utils.js.map